export class GenPlantPersonEntity{


    id: number;
    personId:number;
    plantId:number;

    constructor (){}
}